import React, { type FC, useState } from 'react';

import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Expander from '@amzn/meridian/expander';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import moment from 'moment';
import type { AssociateProfileRestriction } from 'src/services/associateProfile/types';

import EmDash from '../emdash';

import RestrictionHeader from './restrictionHeader';

interface RestrictionCardLayoutProps {
  restriction: AssociateProfileRestriction;
}

const RestrictionCardLayout: FC<RestrictionCardLayoutProps> = ({ restriction }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card spacingInset="100 500" minWidth="750px">
      <Expander type="list" open={isOpen} onChange={setIsOpen} title={<RestrictionHeader restriction={restriction} />}>
        <Row spacing="600">
          <Column>
            <Text color="secondary">End Date</Text>
            {restriction.endAt.length > 0 ? <Text>{moment(restriction.endAt).format('MM/DD/YYYY')}</Text> : <EmDash />}
          </Column>
          <Column>
            <Text color="secondary">Body Location</Text>
            {restriction.bodyLocation ? <Text>{restriction.bodyLocation}</Text> : <EmDash />}
          </Column>
          <Column>
            <Text color="secondary">Cannot perform exceeding (hrs)</Text>
            {restriction.hoursRestricted.length > 0 ? <Text>{restriction.hoursRestricted}</Text> : <EmDash />}
          </Column>
        </Row>
      </Expander>
    </Card>
  );
};

export default RestrictionCardLayout;
